// @ts-strict-ignore
import { useFeatureGate } from "@statsig/react-bindings";

import constants from "../constants";

const useStatsigFeatureGate = (featureGateName) => {
	const result = useFeatureGate(featureGateName);

	// If we are on local domain we don't need to hide any particular features.
	// If we are on the cypress machine we need all the feature gates to return true 
	// so the cypress tests can work properly
	if (!process.env.REACT_APP_DOMAIN || process.env.REACT_APP_DOMAIN === constants.CYPRESS_REACT_APP_DOMAIN) {
		return {
			...result,
			value: true
		};
	}

	return result;
};

export default useStatsigFeatureGate;
